export default __webpack_public_path__ + "static/media/sc43.9a9b5885.jpg";